export default __webpack_public_path__ + "static/media/LAS0840.34I-39022_-22875_0.bdfd5d7a.jpg";